export const classes = {
  header: 'sticky top-0 z-10 shrink-0 px-3 py-4 backdrop-blur-sm',
  body: 'flex flex-col gap-4 pb-4',
  sectionLabel:
    'text-xs uppercase tracking-wide text-taupe-1 font-medium px-1 mb-1 dark:text-mauve-3',
  list: 'flex flex-col gap-1 px-1',
  empty: 'text-sm text-taupe-1 text-center py-8 dark:text-mauve-3',
};
